import React from 'react';
import MUITextField from '@mui/material/TextField';

export type UCNFieldProps = {
    name: string;
    label: string;
    required?: boolean;
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
};

const UCNField = ({ name, label, required, onBlur, ...rest }: UCNFieldProps) => {
    return <MUITextField required={required} name={name} label={label} onBlur={onBlur} {...rest} />;
};

export default UCNField;
